import { Component, Input, Output, EventEmitter, OnInit,OnChanges } from '@angular/core';

export interface TokenData {
    token?: string;
    is_active?: boolean;
    created_at?: string;
    last_used?: string;
    expires_at?: string;
}

export interface TokenUser {
    _id: string;
    email?: string;
    username?: string;
    [key: string]: any;
}

export interface TokenConfig {
    title?: string;
    subtitle?: string;
    showExpiryDate?: boolean;
    showLastUsed?: boolean;
    showCreatedDate?: boolean;
    generateButtonText?: string;
    revokeButtonText?: string;
}

@Component({
    selector: 'app-token-management',
    templateUrl: './token-management.component.html'
})
export class TokenManagementComponent implements OnInit,OnChanges {
    @Input() user!: TokenUser;
    @Input() tokenData: TokenData | null = null;
    @Input() isLoading: boolean = false;
    @Input() config: TokenConfig = {};
    @Input() freshToken: string = '';
    @Output() onGenerate = new EventEmitter<TokenUser | null>();
    @Output() onRevoke = new EventEmitter<TokenUser | null>();
    @Output() onClose = new EventEmitter<void>();

    currentToken = '';
    maskedToken = '';
    revealToken = false;
    copySuccess = false;

    defaultConfig: TokenConfig = {
        title: 'API Token Management',
        subtitle: 'Security',
        showExpiryDate: true,
        showLastUsed: true,
        showCreatedDate: true,
        generateButtonText: 'Generate',
        revokeButtonText: 'Revoke'
    };

    ngOnInit() {
        this.config = { ...this.defaultConfig, ...this.config };
        this.updateMaskedToken();
    }

    // ngOnChanges() {
    //     this.revealToken = false;
    //     this.currentToken = '';
    //     this.copySuccess = false;
    //     this.updateMaskedToken();
    // }
    ngOnChanges() {
    this.revealToken = false;
    this.copySuccess = false;
    if (this.freshToken) {
        this.currentToken = this.freshToken;
        this.revealToken = true;
    }
    this.updateMaskedToken();
}

    updateMaskedToken() {
        const token = this.tokenData?.token;
        if (this.tokenData?.is_active && token && typeof token === 'string') {
            this.maskedToken = '••••••••••••••••••••' + token.slice(-4);
        }
    }

    generateToken() {
        this.onGenerate.emit(this.user);
    }

    revokeToken() {
        this.onRevoke.emit(this.user);
    }

    closeModal() {
        this.onClose.emit();
    }

    toggleReveal() {
        if (!this.tokenData?.token) return;
        this.revealToken = !this.revealToken;
    }

    copyToken() {
        const tokenToCopy = this.currentToken || this.tokenData?.token;
        if (!tokenToCopy) return;
        navigator.clipboard.writeText(tokenToCopy).then(() => {
            this.copySuccess = true;
            setTimeout(() => this.copySuccess = false, 2000);
        });
    }

    setCurrentToken(token: string) {
        if (!token || typeof token !== 'string') return;
        this.currentToken = token;
        this.maskedToken = '••••••••••••••••••••' + token.slice(-4);
        this.revealToken = true;
    }
}